<template>
	<div class="landRanking">
		landRanking
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'landRanking'
	}
</script>

<style scoped>

</style>
